import { Box, useTheme } from '@mui/material';
import Image from 'next/image';
import React, { FC } from 'react';

interface AudioContainerProps {
  audioUrl: string;
  imageUrl: string;
  isSuccessScreen?: boolean;
}

const AudioContainer: FC<AudioContainerProps> = ({ audioUrl, imageUrl, isSuccessScreen }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Image
        src={imageUrl}
        alt="NFT Thumbnail"
        width={500}
        height={500}
        style={{
          width: isSuccessScreen ? '100%' : '90%',
          height: '300px !important',
          objectFit: 'cover',
          position: 'absolute',
          overflow: 'hidden',
          borderRadius: isSuccessScreen ? '0%' : '50%'
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          height: '50px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <audio
          controls
          controlsList="nodownload"
          style={{
            width: '90%',
            position: 'absolute',
            bottom: 0,
            zIndex: 1,
            padding: '10px'
          }}
        >
          <source
            style={{
              backgroundColor: theme?.palette?.background?.paper
            }}
            src={audioUrl}
            type="audio/mpeg"
          />
          Your browser does not support the audio element.{' '}
        </audio>
      </Box>
    </Box>
  );
};

export default AudioContainer;
